/**
 * Message id that should show a plain "Seen" receipt, or null.
 * @param {Array<{ message_id: number, sender_id?: string, created_at?: string }>} messages
 * @param {string|null} currentUserId
 * @param {string|null|undefined} peerLastReadAt - ISO watermark (1:1)
 * @param {Array<{ user_id: string, last_read_at?: string|null }>|null} [memberReadAt] - partner others
 */
export function findSeenReceiptMessageId(
  messages,
  currentUserId,
  peerLastReadAt,
  memberReadAt = null
) {
  if (!currentUserId || !Array.isArray(messages) || !messages.length) {
    return null;
  }

  let coverageMs = null;
  if (Array.isArray(memberReadAt) && memberReadAt.length > 0) {
    const times = memberReadAt
      .map((m) => (m?.last_read_at ? new Date(m.last_read_at).getTime() : NaN))
      .filter((t) => Number.isFinite(t));
    if (times.length < memberReadAt.length) return null;
    coverageMs = Math.min(...times);
  } else if (peerLastReadAt) {
    const t = new Date(peerLastReadAt).getTime();
    if (!Number.isFinite(t)) return null;
    coverageMs = t;
  } else {
    return null;
  }

  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const m = messages[i];
    if (!m || m.sender_id !== currentUserId) continue;
    if (m.deleted_at) continue;
    const created = new Date(m.created_at).getTime();
    if (!Number.isFinite(created)) continue;
    if (created <= coverageMs) return m.message_id;
    return null;
  }
  return null;
}
